import * as React from 'react';
import { useForm } from 'react-hook-form';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Fieldset from 'src/components/project-billing/components/FieldSetComponent';
import CreditCardType from 'src/models/AP/CreditCardType';

export interface ICreditCardStatementSearchCriteria {
    creditCardType?: string;
    statementDate?: Date;
    periodBeginDate?: Date;
    periodEndDate?: Date;
}

interface ICreditCardStatementSearchProps {
    creditCardTypes?: Array<CreditCardType>;
    runQuery?: (criteria: ICreditCardStatementSearchCriteria) => void;
}

// All fields here are query-by-example criteria: typing/selecting only updates local component
// state. Nothing is looked up or fetched until the user clicks "Search".
const CreditCardStatementSearch = (props: ICreditCardStatementSearchProps) => {
    const { register, errors, setValue, getValues } = useForm();

    const creditCardTypeOptions = props?.creditCardTypes?.map((c) => ({ value: `${c.id}`, label: c.name })) ?? [];

    const toDate = (dateStr: string) => (!!dateStr ? new Date(dateStr) : undefined);

    const executeSearch = () => {
        const values = getValues();
        const criteria: ICreditCardStatementSearchCriteria = {
            creditCardType: values.creditCardTypeSearch,
            statementDate: toDate(values.statementDateSearch),
            periodBeginDate: toDate(values.periodBeginDateSearch),
            periodEndDate: toDate(values.periodEndDateSearch),
        };

        if (props?.runQuery) {
            props.runQuery(criteria);
        }
    };

    const clearSearchFilters = () => {
        setValue('creditCardTypeSearch', '');
        setValue('statementDateSearch', '');
        setValue('periodBeginDateSearch', '');
        setValue('periodEndDateSearch', '');
    };

    return (
        <Page className={'dlc-maxer-width'} style={{ justifyContent: 'center' }}>
            <Page.Section width={12}>
                <Panel backgroundColor="#D3D3D3">
                    <Panel panelTitle="Credit Card Statement Search">
                        <form>
                            <div className="form-row" style={{ padding: '.5rem', margin: '0' }}>
                                <div style={{ width: '20%' }}>
                                    <Fieldset label={'Credit Card'} style={{ border: 0, padding: 0 }}>
                                        <RHFSelect
                                            name="creditCardTypeSearch"
                                            options={creditCardTypeOptions}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </Fieldset>
                                </div>
                                <div style={{ width: '18%', paddingLeft: '4px' }}>
                                    <Fieldset label={'Statement Date'} style={{ border: 0, padding: 0 }}>
                                        <RHFInputBox
                                            register={register}
                                            name="statementDateSearch"
                                            type="date"
                                            clearable={true}
                                            setValue={setValue}
                                            defaultVal={''}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </Fieldset>
                                </div>
                                <div style={{ width: '18%', paddingLeft: '4px' }}>
                                    <Fieldset label={'Period Begin'} style={{ border: 0, padding: 0 }}>
                                        <RHFInputBox
                                            register={register}
                                            name="periodBeginDateSearch"
                                            type="date"
                                            clearable={true}
                                            setValue={setValue}
                                            defaultVal={''}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </Fieldset>
                                </div>
                                <div style={{ width: '18%', paddingLeft: '4px' }}>
                                    <Fieldset label={'Period End'} style={{ border: 0, padding: 0 }}>
                                        <RHFInputBox
                                            register={register}
                                            name="periodEndDateSearch"
                                            type="date"
                                            clearable={true}
                                            setValue={setValue}
                                            defaultVal={''}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </Fieldset>
                                </div>
                                <Button
                                    text={'Search'}
                                    className="blue-hover-button"
                                    style={{ width: '7rem', height: '3rem', verticalAlign: 'middle', marginLeft: '1rem', marginTop: '1.7rem', borderRadius: '5px' }}
                                    onClick={() => executeSearch()}
                                />
                                <Button
                                    text="Clear"
                                    className="blue-hover-button"
                                    style={{ whiteSpace: 'nowrap', marginLeft: '1rem', marginTop: '1.7rem', width: '7rem', height: '3rem', verticalAlign: 'middle', borderRadius: '5px' }}
                                    onClick={() => clearSearchFilters()}
                                />
                            </div>
                        </form>
                    </Panel>
                </Panel>
            </Page.Section>
        </Page>
    );
};

export default CreditCardStatementSearch;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/components/CreditCardStatementSearch.tsx